import React from 'react';
import { WMSTileLayer } from 'react-leaflet';

const initPathWMS3 = process.env.REACT_APP_WMS3;

export default function LayerRiver({ visible }) {
  if (!visible) return null;
  return (
    <WMSTileLayer
      url={`${initPathWMS3}`}
      version="1.1.0"
      opacity={1}
      transparent
      layers="spm:stream_main_84utf8"
      format="image/png"
      zIndex={200}
    />
  );
}